import React from 'react';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import { resetPasswordInitialStep as resetPasswordLocales } from 'globals/locales/registration';
import defaultLocales from 'globals/locales/default';
import FsBody from 'ui-elements/typography/FsBody';
import FsLink from 'ui-elements/links/FsLink';
import {
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import FsResetPasswordForm from 'ui-elements/forms/FsResetPasswordForm';
import { WrapperBox } from './ResetPasswordInitialStep.style-elements';

interface LoginProps {
  onGoNext?: () => void;
}

const ResetPasswordInitialStep: React.FC<LoginProps> = ({ onGoNext }) => {
  const handleSuccess = () => {
    if (onGoNext) onGoNext();
  };

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{resetPasswordLocales.hello}</FsHello>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{resetPasswordLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>{resetPasswordLocales.subTitle}</FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsResetPasswordForm onSuccess={handleSuccess} />
      </Box>
      <Box marginTop={3}>
        <FsBody>
          {defaultLocales.logInGoBackQuestion}{' '}
          <FsLink to={Routes.LOGIN}>{defaultLocales.logIn}</FsLink>
        </FsBody>
      </Box>
    </WrapperBox>
  );
};

export default ResetPasswordInitialStep;
